import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom"; // <-- useHistory for v5
import DashboardComponent from "../../components/DashboardComponent/DashboardComponent";
import Layout from "../../components/Layouts/WithAuth/Layout";
import { useAuthContext } from "../../context/AuthContext";

const DashboardScreen = () => {
  const { userDetails } = useAuthContext();
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(true);

  const user_primary_role = JSON.parse(userDetails).user_primary_role;
  const user_slug = JSON.parse(userDetails).user_slug;

  useEffect(() => {
    if (user_slug) {
      if (user_primary_role === "3") {
        history.push(`/resources/details/${user_slug}`);
      } else {
        setIsLoading(false);
      }
    }
  }, [user_slug, user_primary_role, history]);

  return (
    <Layout pageTitle={`FirmConnector :: My Dashboard`}>
      {!isLoading && <DashboardComponent />}
    </Layout>
  );
};

export default DashboardScreen;
